export const featureFlags = (featureFlagClient, featureFlags, data) => {
  const allFeatureFlags = [...featureFlags, ...(data.featureFlags || [])];
  if (allFeatureFlags.length === 0) {
    return null;
  }
  const initialMemo = [];
  allFeatureFlags.reduce((memo, featureFlagKey) => {
    const ffVal = featureFlagClient.getValue(featureFlagKey);
    if (ffVal !== undefined && ffVal !== null) {
      memo.push([featureFlagKey, ffVal]);
    }
    return memo;
  }, initialMemo);
  const mappedFeatureFlags = Object.fromEntries(initialMemo);
  return {
    featureFlags: mappedFeatureFlags
  };
};